import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import Color from '@tool/color';
import { CloseIcon20 } from '@styled/icon';
import { newRate } from '@tool/index';
import PDF from '../component/pdf';
import Title from '../component/title';
import SalaryIndustryPDF from './salary-up/salary-industry/pdf';
import SalaryYearPDF from './salary-up/salary-year/pdf';
import SalaryCityPdf from './salary-up/salary-city/pdf';
import IndustryLeaveRatePDF from './industry-leave-rate/pdf';
import FreshCityPDF from './fresh-salary/fresh-city/pdf';
import FreshCategoryPDF from './fresh-salary/fresh-category/pdf';
import FreshYearPDF from './fresh-salary/fresh-year/pdf';
import CityDiffPDF from './city-different/pdf';
import StaticPage from '../component/static-page';
import SectionBoundary from '../component/section-boundary';
import moIndex from '../store';

interface IProps {}
interface IState {}

const HumanIndicatorPDF = (props: IProps, state: IState) => {
  const navi = useNavigate();

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <>
      <StaticPage
        url="https://file.smartsalary.cn/index-pdf/05.png"
        head={true}
        showuuid={false}
        onetitle="人力资源核心指标"
        twotitle={moIndex.industry.name}/>
      <section id="salary-up">
        <SectionBoundary name="涨薪率-行业"><SalaryIndustryPDF /></SectionBoundary>
        <SectionBoundary name="涨薪率-时间趋势"><SalaryYearPDF /></SectionBoundary>
        <SectionBoundary name="涨薪率-城市"><SalaryCityPdf /></SectionBoundary>
      </section>
      <section id="leave-rate">
        <SectionBoundary name="行业离职率"><IndustryLeaveRatePDF /></SectionBoundary>
      </section>
      <section id="fresh-salary">
        <SectionBoundary name="应届生起薪-年份"><FreshYearPDF /></SectionBoundary>
        <SectionBoundary name="应届生起薪-职能"><FreshCategoryPDF /></SectionBoundary>
        <SectionBoundary name="应届生起薪-城市"><FreshCityPDF /></SectionBoundary>
      </section>
      <section id="city-diff">
        <SectionBoundary name="城市薪酬差异系数"><CityDiffPDF /></SectionBoundary>
      </section>
    </>
  );
};

export default observer(HumanIndicatorPDF);
